import type React from 'react';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => (
  <div className="flex min-h-[calc(100dvh)] flex-col">
    <div className="flex grow flex-col items-center justify-center">
      <div className="flex w-full max-w-screen-2xl grow flex-col">
        <div className="flex w-full grow flex-col">{children}</div>
      </div>
    </div>
  </div>
);

export default DashboardLayout;
